<template>
	<div>
		<h1>cookieless</h1>
		<p>Demo Anmeldung KSR ohne Cookies.<br />Der CustomerIdentityToken wird im Session Storage gespeichert und jedem Aufruf an die API als Parameter mitgegeben.</p>
		<button class="btn btn-primary mb-2" @click="openLoginWindow()" v-if="!identityToken">Anmelden</button>
		<button class="btn btn-danger mb-2" @click="logout()" v-if="identityToken">Abmelden</button>
		<div v-if="identityToken">
			Benutzer ist angemeldet.
		</div>
		<div v-else>
			Benutzer ist nicht angemeldet.
		</div>
		<hr class="my-2 mb-4" />
		<div v-if="identityToken">
			<button class="btn btn-primary mb-2" @click="getJobs()" :disabled="loading">
				<div class="spinner-border text-white mr-2" role="status" v-if="loading">
                    <span class="sr-only">Loading...</span>
                </div>
				Info & Aufträge abholen
			</button>
			<p>Ruft <em>CustomerIdentities/GetInfo</em> und <em>CustomerIdentities/Jobs</em> auf.</p>
			<textarea rows="20" class="form-control" v-if="userstatus">{{ userstatus }}</textarea>
		</div>
	</div>
</template>

<script>

    export default {

    	data() {
            return {
            	identityToken: false,
            	userstatus: false,
            	loading: false
            };
        },

        mounted() {
        	const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const identityToken = urlParams.get('identityToken');
            if(identityToken) {
            	sessionStorage.setItem('identityToken', identityToken);
            	this.identityToken = identityToken;
            	urlParams.delete('identityToken');
            	history.replaceState(null, '', '?' + urlParams);
            }
            else {
            	let identityTokenFromSession = sessionStorage.getItem('identityToken');
            	this.identityToken = identityTokenFromSession;
            }
        },

        computed: {
        },

        methods: {

            openLoginWindow(section = 'kl') {
                var w = 400;
                var h = 500;
                var left = (screen.width/2)-(w/2);
                var top = (screen.height/2)-(h/2);
                if(window.location.href.indexOf("/s/") != -1)
                    window.open('/s/pre.booklyn.io/ksrlogin/' + this.studioId + '?cookieless', 'ksrlogin', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
                else
                    window.open('/ksrlogin/' + this.studioId + '?cookieless', 'ksrlogin', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
                //window.open('/ksrlogin','winname','directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=400,height=500');
            },

            logout() {
            	sessionStorage.removeItem('identityToken');
            	this.identityToken = false;
            },

            getJobs() {
            	this.loading = true;
                let url = '/api/ksr/'+this.studioId+'/userstatus/?identityToken='+this.identityToken;
                axios.get(url)
                .catch(function (error) {
                    // empty catch
                    //console.log(error);
                })
                .then((response) => {
                	console.log(response.data);
                	this.userstatus = response.data;
                	this.loading = false;
                    //_this.accountStatus = response.data.status;
                    //if(response.data.status == 10) {
                    /*if(response.data.info.value == null) {
                        // Kunde hat noch kein Werkstattkonto
                        //_this.accountStatus = 10;
                        //_this.onEditAccount();
                        //_this.accountInfo.eMail = response.data.info.value.email;
                    }
                    else {
                        // Kunde hat Werkstatt-Konto
                        //console.log(response.data.info);
                        var customerIdentity = response.data.info.value.customerIdentity;
                        _this.accountInfo.salutation = customerIdentity.salutation;
                        _this.accountInfo.firstName = customerIdentity.firstName;
                        _this.accountInfo.lastName = customerIdentity.lastName;
                        _this.accountInfo.additionalText = customerIdentity.additionalText;
                        _this.accountInfo.mobilePhone = customerIdentity.contactInformation.mobilePhone;
                        _this.accountInfo.eMail = customerIdentity.contactInformation.eMail;
                        _this.accountInfo.street = customerIdentity.postalAddress.street;
                        _this.accountInfo.zipCode = customerIdentity.postalAddress.zipCode;
                        _this.accountInfo.city = customerIdentity.postalAddress.city;

                        _this.accountInfoFull = response.data.info.value;
                        _this.accountInfoJobs = response.data.jobs;
                        _this.accountInfoVehicles = response.data.vehicles;
                        _this.token = response.data.token;

                        if(this.rootSection != 'singlejob') {
                            _this.onLicensePlateInput();
                        }
                    }
                    this.loading = false;*/
                });
            }
        },

        props: ['studioId']

    }
</script>